import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { Login } from '@/features/login/page/Login';

// biome-ignore assist/source/useSortedKeys: order of keys type inference
export const Route = createFileRoute('/auth/login')({
    validateSearch: z.object({ encode: z.string().optional() }),
    component: Login,
    beforeLoad: ({ search }) => {
        if (search.encode) {
            throw redirect({
                replace: true,
                search: { encode: search.encode },
                to: '/auth/login-automatico',
            });
        }
    },
});
